<template>
  <component :is="gameUrl ? 'a' : 'div'" class="minisite-game-card" :class="{ 'minisite-game-card--coming-soon': $i18n.locale === 'en-US' && !game.supportEnglish }" :href="gameUrl || undefined" :target="gameUrl ? '_blank' : undefined" :rel="gameUrl ? 'noopener' : undefined" @click="gameUrl && handleDownload()">
    <div class="minisite-game-card__image">
      <img v-if="imageSrc && !imageFailed" :src="imageSrc" :alt="game.name" @error="imageFailed = true" />
      <span v-else class="minisite-game-card__placeholder">{{ game.name }}</span>
      <span v-if="rank >= 1 && rank <= 3" class="game-rank-badge" :class="`game-rank-badge--${rank}`" :aria-label="$t('rankLabel', { rank })">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z"/><path d="M5 21h14"/></svg>
        <span aria-hidden="true">{{ rank }}</span>
      </span>
    </div>
  </component>
</template>
<script>
import { withQuery } from '@/utils/navigation'
import userTrackingService from '@/api/userTracking'

export default {
  name: 'GameCard',
  data() { return { imageFailed: false } },
  watch: { imageSrc() { this.imageFailed = false } },
  props: {
    game: {
      type: Object,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    },
    queryString: {
      type: String,
      default: ''
    },
    rank: {
      type: Number,
      default: 0
    }
  },
  computed: {
    gameUrl() { return withQuery(this.game.link, this.queryString) },
    imageSrc() { return !this.game.image ? '' : /^https?:\/\//.test(this.game.image) ? this.game.image : `${this.imageUrl}/${this.game.image}` }
  },
  methods: {
    async handleDownload() {
      const isDebug = process.env.NODE_ENV !== 'production'

      // 從遊戲 URL 提取 gameId
      const gameId = this.game.serviceId || userTrackingService.extractGameIdFromUrl(this.game.link)

      if (isDebug) {
        console.debug('[GameCard Mobile] 下載按鈕被點擊', {
          gameName: this.game.name,
          gameLink: this.game.link,
          extractedGameId: gameId
        })
      }

      try {
        // 追蹤下載事件 (從 URL 提取 gameId)
        await userTrackingService.trackDownload({
          gameId
        })

        if (isDebug)
          console.debug('[GameCard Mobile] 追蹤記錄已建立')
      }
      catch (error) {
        if (isDebug)
          console.error('[GameCard Mobile] 追蹤記錄建立失敗，但不阻擋下載', { error })

        // User tracking failed, but don't block the download
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.minisite-game-card { display: block; position: relative; min-width: 0; border-radius: 8px; color: #fff; text-decoration: none; }
.minisite-game-card--coming-soon::after { content: "Coming soon"; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); background: #000c; padding: 8px; border-radius: 4px; }
.minisite-game-card:focus-visible { outline: 2px solid #f5c400; outline-offset: 3px; }
.minisite-game-card__image { position: relative; aspect-ratio: 1; overflow: hidden; border-radius: inherit; }
.minisite-game-card__image > img { display: block; width: 100%; height: 100%; object-fit: cover; }
.minisite-game-card__placeholder { display: flex; align-items: center; justify-content: center; height: 100%; padding: 12px; box-sizing: border-box; background: #30312b; text-align: center; overflow-wrap: anywhere; }
/* Match the official portal's GameRankBadge, including its mobile sizing. */
.game-rank-badge { display: inline-flex; align-items: center; justify-content: center; position: absolute; top: 8px; left: 8px; z-index: 2; gap: 4px; min-width: 32px; height: 30px; padding: 0 8px; border: 1px solid #ffffff94; border-radius: 4px; box-shadow: 0 3px 10px #00000047; font-size: 12px; font-weight: 850; line-height: 1; pointer-events: none; }
.game-rank-badge--1 { background: #f5c400; color: #11120f; border-color: #ffffffb8; }
.game-rank-badge--2 { background: #e7ecf0; color: #171a1c; border-color: #fff; }
.game-rank-badge--3 { background: #a85635; color: #fff; border-color: #f4d5c2; }
@media (max-width: 640px) {
  .game-rank-badge { top: 6px; left: 6px; min-width: 27px; height: 24px; padding: 0 6px; gap: 3px; font-size: 11px; }
  .game-rank-badge svg { width: 12px; height: 12px; }
}
</style>
